import React from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';
import { IntlMessageValue, MIcon } from "../../../../../@WUM/core/Elements";
import {CryptDecrypt} from "../../../../../@WUM/core/Elements/crypt/Crypt";

interface ModuleNotPurchasedPageProps {
    /**
     * Optional: show module name in the title/description.
     */
    moduleName?: string;
}

const THEME = {
    bg: '#F7FAFF',
    border: '#E7EDF5',
    text: '#0F172A',
    muted: '#64748B',
    primary: '#1F7AE0',
    primaryDark: '#155FB3',
    pillBg: '#EAF3FF',
};

const ModuleNotPurchasedPage: React.FC<ModuleNotPurchasedPageProps> = ({ moduleName }) => {
    const Store = useSelector((state: any) => state);

    const shopUrl = 'https://teamtakt.de/produkt-kategorie/module/';
    const pricingUrl = 'https://teamtakt.de/preise/';

    if (
        localStorage.getItem('userRights') !== null && localStorage.getItem('userRights') !== undefined && JSON.parse(CryptDecrypt(localStorage.getItem('userRights') as string) as string).isMandant === true
    ) {
        return (
            <>test</>
        );
    } else {

    }


    return (
        <div
            className="d-flex align-items-center justify-content-center"
            style={{
                minHeight: 'calc(100vh - 120px)',
                padding: 24,
                background: `radial-gradient(900px 450px at 20% 10%, ${THEME.pillBg} 0%, ${THEME.bg} 45%, #ffffff 100%)`,
            }}
        >
            <Card
                style={{
                    width: 'min(920px, 100%)',
                    border: `1px solid ${THEME.border}`,
                    borderRadius: 18,
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
                }}
            >
                <div
                    style={{
                        padding: 18,
                        background: `linear-gradient(90deg, ${THEME.primary} 0%, ${THEME.primaryDark} 100%)`,
                        color: '#ffffff',
                    }}
                    className="d-flex align-items-center justify-content-between gap-3"
                >
                    <div className="d-flex align-items-center gap-3">
                        <div
                            className="d-inline-flex align-items-center justify-content-center"
                            style={{
                                width: 42,
                                height: 42,
                                borderRadius: 12,
                                background: 'rgba(255, 255, 255, 0.14)',
                            }}
                        >
                            <MIcon newMaterial variant="-outlined" style={{ fontSize: 22, lineHeight: '22px' }}>
                                lock
                            </MIcon>
                        </div>

                        <div>
                            <div style={{ fontWeight: 800, fontSize: 16, lineHeight: '18px' }}>
                                {IntlMessageValue('de', 'module.notPurchased.title', Store)}
                            </div>
                            <div style={{ opacity: 0.9, fontSize: 12, marginTop: 2 }}>
                                {IntlMessageValue('de', 'module.notPurchased.subtitle', Store)}
                            </div>
                        </div>
                    </div>
                </div>

                <Card.Body style={{ padding: 22 }}>
                    <div className="d-flex flex-column flex-lg-row gap-3">
                        <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 800, fontSize: 18, color: THEME.text }}>
                                {IntlMessageValue('de', 'module.notPurchased.headline', Store)}
                                {moduleName ? <span style={{ fontWeight: 800 }}> {moduleName}</span> : null}
                            </div>

                            <div style={{ marginTop: 10, fontSize: 13, lineHeight: '18px', color: THEME.muted }}>
                                {IntlMessageValue('de', 'module.notPurchased.description', Store)}
                            </div>

                            <div className="d-flex flex-wrap gap-2" style={{ marginTop: 14 }}>
                                <div
                                    className="d-inline-flex align-items-center gap-2"
                                    style={{
                                        background: THEME.pillBg,
                                        border: `1px solid ${THEME.border}`,
                                        borderRadius: 999,
                                        padding: '6px 10px',
                                        fontSize: 12,
                                        color: THEME.text,
                                    }}
                                >
                                    <MIcon newMaterial variant="-outlined" style={{ fontSize: 16, lineHeight: '16px', color: THEME.primary }}>
                                        shopping_cart
                                    </MIcon>
                                    <span>{IntlMessageValue('de', 'module.notPurchased.pill.buyOnline', Store)}</span>
                                </div>

                                <div
                                    className="d-inline-flex align-items-center gap-2"
                                    style={{
                                        background: '#ffffff',
                                        border: `1px solid ${THEME.border}`,
                                        borderRadius: 999,
                                        padding: '6px 10px',
                                        fontSize: 12,
                                        color: THEME.text,
                                    }}
                                >
                                    <MIcon newMaterial variant="-outlined" style={{ fontSize: 16, lineHeight: '16px', color: THEME.primary }}>
                                        verified
                                    </MIcon>
                                    <span>{IntlMessageValue('de', 'module.notPurchased.pill.activate', Store)}</span>
                                </div>
                            </div>

                            <div className="d-flex flex-column flex-sm-row gap-2" style={{ marginTop: 18 }}>
                                <Button
                                    as="a"
                                    href={shopUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        background: THEME.primary,
                                        borderColor: THEME.primary,
                                        borderRadius: 12,
                                        fontWeight: 800,
                                        padding: '10px 14px',
                                    }}
                                >
                                    <span className="d-inline-flex align-items-center gap-2">
                                        <MIcon newMaterial variant="-outlined" style={{ fontSize: 18, lineHeight: '18px' }}>
                                            open_in_new
                                        </MIcon>
                                        {IntlMessageValue('de', 'module.notPurchased.cta.shop', Store)}
                                    </span>
                                </Button>

                                <Button
                                    as="a"
                                    href={pricingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    variant="outline-primary"
                                    style={{
                                        borderRadius: 12,
                                        fontWeight: 800,
                                        padding: '10px 14px',
                                        borderColor: THEME.primary,
                                        color: THEME.primary,
                                    }}
                                >
                                    {IntlMessageValue('de', 'module.notPurchased.cta.pricing', Store)}
                                </Button>
                            </div>

                            <div style={{ marginTop: 12, fontSize: 12, color: THEME.muted }}>
                                {IntlMessageValue('de', 'module.notPurchased.hint', Store)}
                            </div>
                        </div>

                        <div
                            style={{
                                width: 'min(320px, 100%)',
                                border: `1px solid ${THEME.border}`,
                                borderRadius: 16,
                                padding: 16,
                                background: '#ffffff',
                            }}
                        >
                            <div className="d-flex align-items-center gap-2">
                                <MIcon newMaterial variant="-outlined" style={{ fontSize: 18, lineHeight: '18px', color: THEME.primary }}>
                                    info
                                </MIcon>
                                <div style={{ fontWeight: 800, fontSize: 13, color: THEME.text }}>
                                    {IntlMessageValue('de', 'module.notPurchased.card.title', Store)}
                                </div>
                            </div>

                            <div style={{ marginTop: 8, fontSize: 12, color: THEME.muted, lineHeight: '17px' }}>
                                {IntlMessageValue('de', 'module.notPurchased.card.text', Store)}
                            </div>

                            <ul style={{ marginTop: 10, paddingLeft: 18, fontSize: 12, color: THEME.text }}>
                                <li style={{ marginBottom: 6 }}>
                                    {IntlMessageValue('de', 'module.notPurchased.card.bullet1', Store)}
                                </li>
                                <li style={{ marginBottom: 6 }}>
                                    {IntlMessageValue('de', 'module.notPurchased.card.bullet2', Store)}
                                </li>
                                <li>
                                    {IntlMessageValue('de', 'module.notPurchased.card.bullet3', Store)}
                                </li>
                            </ul>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ModuleNotPurchasedPage;
